<template>
    <v-container>
        <!--v-layout align-center justify-center-->
        

        <v-layout align-center justify-center>
            <v-loading class="loading" v-model="loading" v-if="loading">
                <v-progress-circular persistent :size="70" :width="7" color="primary" indeterminate></v-progress-circular>
            </v-loading>
            <v-flex xs12 sm12 md12>
                <!--v-card class="elevation-12"-->
                <v-card>
                    <v-toolbar dark color="primary">
                        <v-toolbar-title><router-link to="/" class="voltar"><img class="imgVoltar" :src="imgVoltar"></router-link>Meu perfil</v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                        <!--v-form ref="form" v-model="valid" lazy-validation-->
                        <v-form ref="form" v-model="valid" lazy-validation>
                            <v-flex xs12 sm12 text-xs-center>
                                <!-- <img v-bind:src="urlImg" id="myimg" width="100%" /> -->
                                <div
                                    class="img"
                                    v-bind:style="{ 'background-image': 'url(' + urlImg + ')' }"
                                ></div>
                            </v-flex>

                            <v-card-text v-if="show" style="padding:0 0 0 0; width:100%">
                                <!--v-radio-group v-model="opt1"-->
                                <b>Nome: </b>
                                <span>{{nome}}</span>
                                <br />

                                <b v-if="perfilIIDSelected != 7">Celular: </b>
                                <span v-if="perfilIIDSelected != 7">{{celular}}</span>
                                <br v-if="perfilIIDSelected != 7" />

                                <b v-if="perfilIIDSelected != 7">E-mail: </b>
                                <span v-if="perfilIIDSelected != 7">{{email}}</span>
                                <br v-if="perfilIIDSelected != 7" />

                                <div v-if="autorizacao != null">
                                    <div v-if="autorizacao == true">
                                        <b>Autorizado</b> a buscar o aluno
                                    </div>
                                    <div v-if="autorizacao == false">
                                        <b>Não autorizado</b> a buscar o aluno
                                    </div>
                                </div>
                                
                                <br v-if="perfilIIDSelected == 7" />
                                <b v-if="perfilIIDSelected == 7">Meus responsaveis</b>

                                

                                <div v-if="dataAniversario != null">
                                    <b>Data de aniversário: </b>
                                    <span>{{dataAniversario}}</span>
                                    <br />
                                </div>

                                <div v-if="dataVencimentoMensal != null">
                                    <b>Data do vencimento mensal: </b>
                                    <span>{{dataVencimentoMensal}}</span>
                                    <br />
                                    <br />
                                </div>

                                <a v-if="perfilIIDSelected != 7" class="dadosAppLink" @click="dadosApp">Exibir dados do aplicativo</a><br class="dadosAppLink" />
                                <div class="dadosApp" style="display:none">
                                    <div>
                                        <b>Versão do aplicativo: </b>
                                        <span>2.0.7</span>
                                        <br />
                                    </div>
                                    <div>
                                        <b>ID do usuário: </b>
                                        <span>{{IDusuario}}</span>
                                        <br />
                                    </div>
                                    <div>
                                        <b>ID da escola: </b>
                                        <span>{{IDescola}}</span>
                                        <br />
                                    </div>
                                </div>
                                

                                <!-- <label style="font-size:9px; width:100%; word-wrap: break-word; color:red">{{tokenFMC}}</label><br /><br /> -->
                                <div v-if="perfil == 4 && itemsTurmasSelecionadas != '' || perfil == 5 && itemsTurmasSelecionadas != '' || perfil == 6 && itemsTurmasSelecionadas != ''">
                                    <b>Minha(s) Turma(s)</b>
                                    <br />
                                    <div>
                                        <div class="box-items-selecionados">
                                            <v-layout
                                                row
                                                wrap
                                                v-for="itemsTurmasSelecionada in itemsTurmasSelecionadas"
                                            >
                                                <v-flex xs12 sm12 md12>{{ itemsTurmasSelecionada }}</v-flex>
                                            </v-layout>
                                        </div>
                                    </div>
                                    <br />
                                </div>
                                <div v-if="perfil == 4 && itemsResponsaveisSelecionados != '' || perfil == 5 && itemsResponsaveisSelecionados != '' || perfil == 6 && itemsResponsaveisSelecionados != ''">
                                    <b>Responsável</b>
                                    <br />
                                    <div class="box-items-selecionados">
                                        <v-layout
                                            row
                                            wrap
                                            v-for="itemsResponsaveisSelecionado in itemsResponsaveisSelecionados"
                                        >
                                            <v-flex
                                                xs12
                                                sm12
                                                md12
                                            >{{ itemsResponsaveisSelecionado }}</v-flex>
                                        </v-layout>
                                    </div>
                                </div>
                                <br />

                                <div v-if="perfil == 6 && alunosRelacionados != ''" >
                                    <b>Aluno(s)</b>
                                    <br />
                                    <div>
                                        <div v-for="alunoRelacionado in alunosRelacionados">
                                            <v-layout
                                                row
                                                wrap
                                                align-center
                                                @click="dashboard(alunoRelacionado.slug)"
                                                class="box-aluno"
                                            >
                                                
                                                <div v-if="alunoRelacionado.img != undefined"
                                                    class="img2"
                                                    v-bind:style="{ 'background-image': 'url(' + alunoRelacionado.img + ')' }"
                                                ></div>
                                                <v-flex xs9 sm9 md9>{{ alunoRelacionado.nome }}</v-flex>
                                            </v-layout>
                                        </div>
                                    </div>
                                </div>
                            </v-card-text><br />
                            <div v-if="perfil == 6">
                                <b>Meu score</b>
                                <br />
                                    <label class="v-label theme--light">Ano:</label>
                                    <v-flex xs12 sm12 md12>
                                        <v-card-text style="padding:0 0 0 0; width:100%">
                                            <v-select
                                                :items="itemsAnos"
                                                item-value="value.ID"
                                                item-text="value.label"
                                                return-object
                                                v-model="anos"
                                                v-on:change="changeYear"
                                            ></v-select>
                                            <h3>Pontuação: {{pontosAno}}</h3>
                                        </v-card-text>
                                    </v-flex>
                                    <br />

                                    <label class="v-label theme--light">Mês:</label>
                                    <v-flex xs12 sm12 md12>
                                        <v-card-text style="padding:0 0 0 0; width:100%">
                                            <v-select
                                                :items="itemsMeses"
                                                item-value="value.ID"
                                                item-text="value.label"
                                                return-object
                                                v-model="meses"
                                                v-on:change="changeMonth"
                                            ></v-select>
                                            <h3>Pontuação: {{pontosMes}}</h3>
                                        </v-card-text>
                                    </v-flex>
                                    <br /><br /><br />
                                
                            </div>

                            <div v-if="perfil == 2 || perfil == 3 || perfil == 4">
                                <template>
                                    <v-btn
                                        block
                                        color="primary"
                                        @click="$router.push(`/dashboard-escola`)"
                                        large
                                    >Visualizar dashboard</v-btn>
                                </template>
                            </div>
                            <br />
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <!--v-btn color="primary" :disabled="!valid" @click="submit" data-cy="joinSubmitBtn">Cadastrar</v-btn-->
                        <!--v-btn color="primary" :disabled="!valid || !statusUpload" @click="submit" data-cy="joinSubmitBtn">Atualizar</v-btn-->
                    </v-card-actions>
                </v-card>

                <!-- <template v-if="perfil == 1 || perfil == 2">
                    <v-layout>
                        <v-flex >
                        <v-card>
                            <v-container grid-list-sm fluid>
                                <v-layout row wrap>
                                    <v-flex :key="n" xs12 d-flex>
                                        <v-card flat tile class="d-flex" @click="dashboardEscola">
                                            <v-img
                                            :src="`https://picsum.photos/500/300?image=20`"
                                            :lazy-src="`https://picsum.photos/500/300?image=20`"
                                            aspect-ratio="5"
                                            class="grey lighten-2"
                                            >
                                            <template v-slot:placeholder>
                                                <v-layout
                                                fill-height
                                                align-center
                                                justify-center
                                                ma-0
                                                >Dashboard
                                                </v-layout>
                                            </template>
                                            </v-img>
                                        </v-card>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-card>
                        </v-flex>
                    </v-layout>
                    
                </template>-->
            </v-flex>
        </v-layout>
        <v-dialog v-model="dialog" persistent max-width="290">
            <v-card>
                <v-card-title class="headline">{{tituloModal}}</v-card-title>
                <!--v-card-text>Let Google help apps determine location. This means sending anonymous location data to Google, even when no apps are running.</v-card-text-->
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <!--v-btn color="green darken-1" flat @click="dialog = false">Disagree</v-btn-->
                    <v-btn color="green darken-1" flat @click="closeModal">OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import db from './firebaseInit';
import firebase, { storage } from 'firebase';

import { mask } from 'vue-the-mask';

import { userProperties, usersData } from '@/global.js';

import ApexCharts from 'apexcharts';

import imgVoltar from '../assets/ic-voltar.png';

// es2015 module
import Vue from 'vue';
import VueCookies from 'vue-cookies';
Vue.use(VueCookies);

var now = new Date();
var year = '' + now.getFullYear();
var month = '' + (now.getMonth() + 1);
if (month.length == 1) {
    month = '0' + month;
}
var day = '' + now.getDate();
if (day.length == 1) {
    day = '0' + day;
}
var hour = '' + now.getHours();
if (hour.length == 1) {
    hour = '0' + hour;
}
var minute = '' + now.getMinutes();
if (minute.length == 1) {
    minute = '0' + minute;
}
var second = '' + now.getSeconds();
if (second.length == 1) {
    second = '0' + second;
}

export default {
    name: 'Perfil',
    directives: { mask },
    data() {
        return {
            imgVoltar: imgVoltar,
            IDusuario: userProperties.slug,
            IDescola: userProperties.escolaID,
            meuPerfil: userProperties.perfil,
            pontosAno: 0,
            pontosMes: 0,
            anos: {
                value: {
                    ID: year,
                    label: year
                } //,
                //text: '2018'
            },
            itemsAnos: [
                {
                    value: {
                        ID: '2018',
                        label: '2018'
                    } //,
                    //text: '2018'
                },
                {
                    value: {
                        ID: '2019',
                        label: '2019'
                    }
                    //text: '2019'
                },
                {
                    value: {
                        ID: '2020',
                        label: '2020'
                    }
                    //text: '2019'
                }
            ],
            meses: {
                value: {
                    ID: month
                } //,
                //text: '2018'
            },
            itemsMeses: [
                {
                    value: {
                        ID: '01',
                        label: 'Janeiro'
                    }
                },
                {
                    value: {
                        ID: '02',
                        label: 'Fevereiro'
                    }
                },
                {
                    value: {
                        ID: '03',
                        label: 'Março'
                    }
                },
                {
                    value: {
                        ID: '04',
                        label: 'Abril'
                    }
                },
                {
                    value: {
                        ID: '05',
                        label: 'Maio'
                    }
                },
                {
                    value: {
                        ID: '06',
                        label: 'Junho'
                    }
                },
                {
                    value: {
                        ID: '07',
                        label: 'Julho'
                    }
                },
                {
                    value: {
                        ID: '08',
                        label: 'Agosto'
                    }
                },
                {
                    value: {
                        ID: '09',
                        label: 'Setembro'
                    }
                },
                {
                    value: {
                        ID: '10',
                        label: 'Outubro'
                    }
                },
                {
                    value: {
                        ID: '11',
                        label: 'Novembro'
                    }
                },
                {
                    value: {
                        ID: '12',
                        label: 'Dezembro'
                    }
                }
            ],
            valid: false,
            nome: '',
            email: '',
            password: '',
            perfil: userProperties.perfil,
            escolaID: 0,
            dialog: false,
            loading: false,
            slug: this.slug,
            extensao: null,
            urlImg: null,
            autorizacao: null,
            statusUpload: true,
            tituloModal: 'Usuário atualizado com sucesso!',
            turmas: '',
            itemsTurmas: [],
            itemsTurmasSelecionadas: [], //itemsTurmasSelecionadas: ["turma 1 teste","turma 1 teste 2"],
            responsaveis: '',
            itemsResponsaveis: [],
            itemsResponsaveisSelecionados: [],
            alunosRelacionados: [],
            itemsAlunos: [],
            alunos: {
                // alunoSlug: 1,
                // alunoName: 'Alice'
            },
            itemsAlunos: [
                // {
                //         alunoSlug: 0,
                //         alunoName: 'Laura'
                // },
                // {
                //         alunoSlug: 1,
                //         alunoName: 'Alice'
                // }
            ],
            alunoSlug: null,
            itemsAlunosSelecionados: [],
            perfilNameSelected: null,
            perfilIIDSelected: null,
            show: false,
            tokenFMC: null,
            dataAniversario: null,
            dataVencimentoMensal: null,
            celular: null,
            nomeRules: [
                v => !!v || 'Nome é obrigatório',
                v => v.length >= 4 || 'A senha deve ter mais de 3 characteres'
            ],
            perfilUsuario: '',
            itemsPerfilUsuario: [
                //{id: 1, name: 'Administrador'}, // Pode criar usuários do tipo escola somente. Não cria outros tipos de usuarios.
                //{id: 2, name: 'Escola'}, // Somente esse perfil cria os perfis de usuários abaixo
                { id: 3, name: 'Administrativo' }, // Pode criar os conteúdos mas não fica atrelado a uma turma
                { id: 4, name: 'Administrativo/Professor' }, // Pode criar conteúdos e fica atrelado a uma turma
                { id: 5, name: 'Professor' }, // Fica atrelado a uma turma mas não pode criar conteúdos
                { id: 6, name: 'Responsável' }, // Pode comentar postagens, usar chat, e ver relatório dos seus alunos atrelados
                { id: 7, name: 'Aluno' } // Não faz login no sistema, não precisa nem criar usuário no auth do Firebase, apenas no banco de dados
            ],
            emailRules: [
                v => !!v || 'E-mail é obrigatório',
                v => /.+@.+/.test(v) || 'E-mail deve ser válido.'
            ],
            passwordRules: [
                v => !!v || 'Senha obrigatória',
                v => v.length >= 7 || 'A senha deve ter mais de 6 characteres'
            ],
            anoSelecionado: year,
            mesSelecionado: month
        };
    },
    methods: {
        // ####################### Criar parte que criar documentos collections de cada escola ao realizar primeiro login do usuario Escola
        dadosApp(){
            $(".dadosApp").slideDown("fast");
            $(".dadosAppLink").hide();

            // Google Analytics - Events
            gtag('event', 'clicou', {
                'event_category': 'perfil',
                'event_label': 'exibir dados do aplicativo'//,
                //'value': '<value>'
            });
        },
        closeModal() {
            this.$router.push(`/Cadastro-Usuarios-Listagem`);
        },
        dashboard(slug) {
            this.$router.push(`/dashboard-aluno?slug=` + slug);
        },
        changeMonth(selected) {
            this.pontosMes = 0;
            try {
                this.mesSelecionado = selected.value.ID;
            } catch (err) {
                this.mesSelecionado = month;
            }

            db.collection('log_' + userProperties.escolaID)
                .where('slugAutor', '==', this.$route.query.slug)
                .where('ano', '==', this.anoSelecionado)
                .where('mes', '==', this.mesSelecionado)
                .get()
                .then(querySnapshot => {
                    if (querySnapshot.size == 0) {
                        this.pontosMes = 0;
                    } else {
                        var pontuacao = 0;
                        querySnapshot.forEach(doc => {
                            // doc.data() is never undefined for query doc snapshots
                            console.log(doc.id, ' => ', doc.data());

                            let customObj = doc.data();
                            pontuacao = pontuacao + Number(customObj.pontos);
                        });

                        this.pontosMes = pontuacao;
                    }

                    this.loading = false;
                })
                .catch(err => {
                    console.log('ERRO AO CONSULTAR DIÁRIO: ', err);
                    this.loading = false;
                    this.resumo = false;
                    alert('Erro ao consultar diário.');
                });
        },
        changeYear(selected) {
            this.pontosAno = 0;
            try {
                this.anoSelecionado = selected.value.ID;
            } catch (err) {
                this.anoSelecionado = year;
            }

            db.collection('log_' + userProperties.escolaID)
                .where('slugAutor', '==', this.$route.query.slug)
                .where('ano', '==', this.anoSelecionado)
                .get()
                .then(querySnapshot => {
                    if (querySnapshot.size == 0) {
                        this.pontosMes = 0;
                        this.pontosAno = 0;
                    } else {
                        var pontuacao = 0;
                        querySnapshot.forEach(doc => {
                            // doc.data() is never undefined for query doc snapshots
                            console.log(doc.id, ' => ', doc.data());

                            let customObj = doc.data();
                            pontuacao = pontuacao + Number(customObj.pontos);
                        });

                        this.pontosAno = pontuacao;
                        this.changeMonth();
                    }

                    this.loading = false;
                })
                .catch(err => {
                    console.log('ERRO AO CONSULTAR DIÁRIO: ', err);
                    this.loading = false;
                    this.resumo = false;
                    alert('Erro ao consultar diário.');
                });
        },
        dashboardEscola() {
            this.$router.push(`/dashboard-escola`);
        },
        perfilUsuarioID(e) {
            if (e.target.options.selectedIndex > -1) {
                console.log(
                    e.target.options[e.target.options.selectedIndex].value
                );
                this.perfil =
                    e.target.options[e.target.options.selectedIndex].value;
            }
        },
        onFileSelected(event) {
            this.loading = true;
            console.log(event);
            var file = event.target.files[0];
            var filename = event.target.files[0].name;

            // Recupera imagem do storage
            var storageRef = firebase
                .storage()
                .ref(
                    'profile/' +
                        this.slug +
                        '.' +
                        filename.toString().split('.')[1]
                );
            this.extensao = filename.toString().split('.')[1];
            var task = storageRef.put(file);
            var that = this;
            task.on(
                'state_changed',
                function progress(snapshot) {
                    var percentage =
                        (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                    uploader.value = percentage;
                    that.loading = false;
                },
                function error(err) {
                    alert(
                        'Error on upload. Check if image size is less than 900KB'
                    );
                    that.statusUpload = false;
                    that.loading = false;
                },
                function complete() {
                    that.extensao = filename.toString().split('.')[1];
                    that.statusUpload = true;
                    alert('Upload successful!');
                    that.loading = false;
                }
            );
        }
    },
    mounted() {
        // Google Analytics - Pageview
        this.$ga.page({
            page: window.location.href,
            title: 'Perfil',
            location: "/perfil"
        })

        // Popula o numero de quantidade de notificações
        db.collection('notificacoes').where("destinatario", "==", userProperties.slug)
        .get()
        .then((querySnapshot) => {
            // set cookie
            $.cookie("qtdNotificacoes", querySnapshot.size, { expires: 60 });
            
            
        });

        this.changeMonth();
        this.changeYear();

        if (userProperties.perfil == 6) {
            // responsaveis
            // Monta objeto com todos os alunos da escola
            var todosAlunos = [];
            usersData.usuarios.forEach(function(item, index) {
                if (item.perfil == 7) {
                    todosAlunos.push(item);
                }
            });

            var img;

            // Procura em cada aluno se o usuário logado está atrelado
            var alunosRelacionados = []; // objeto com alunos atrelados!!!
            var alunosRelacionadosCompleto = []; // objeto com alunos atrelados com todas as propriedades
            //var alunoAtual = [];
            usersData.usuarios.forEach(function(item, index) { // monta a lista com os alunos relacionados ao usuario logado
                if(userProperties.slug == item.slug){
                    alunosRelacionados.push(item.alunos)
                }
            });
            alunosRelacionados[0].forEach((item, index) => {
                // Busca nome pelo Slug
                usersData.usuarios.forEach((item2, index2) => {
                    if(item2.slug == item.alunoSlug){
                        alunosRelacionadosCompleto.push(item2)
                    }
                });
            });

            console.log("resultado final.");
            console.log(alunosRelacionadosCompleto);
            
            alunosRelacionadosCompleto.forEach(function(item, index) {
                var storageRef = firebase.storage().ref();
                var tangRef = storageRef.child(
                    'profile/' + item.slug + '.' + item.extensao
                );
                tangRef
                    .getDownloadURL()
                    .then(urlImgFB => {
                        // Once we have the download URL, we set it to our img element
                        //console.log(urlImgFB);

                        alunosRelacionados.push({
                            slug: item.slug,
                            img: urlImgFB,
                            nome: item.nome
                        });
                    })
                    .catch(function(error) {
                        // If anything goes wrong while getting the download URL, log the error,
                        alunosRelacionados.push({
                            slug: item.slug,
                            nome: item.nome
                        });
                    });
                // if (item.responsaveis.length != 0) {
                //     console.log(item.responsaveis.length);
                //     item.responsaveis.forEach(function(item2, index2) {
                //         if (item2.responsavelSlug == userProperties.slug) {
                            
                //         }
                //     });
                // }
            });

            console.log(alunosRelacionados);
            this.alunosRelacionados = alunosRelacionados;
        }

        db.collection('usuarios')
            .where('slug', '==', this.$route.query.slug)
            .get()
            .then(querySnapshot => {
                querySnapshot.forEach(doc => {
                    // doc.data() is never undefined for query doc snapshots
                    console.log(doc.id, ' => ', doc.data());
                    let customObj = doc.data();
                    this.email = customObj.email;
                    this.nome = customObj.nome;
                    this.extensao = customObj.extensao;
                    this.slug = customObj.slug;
                    this.perfilIIDSelected = customObj.perfil;
                    this.itemsTurmasSelecionadas = customObj.turmas;
                    this.itemsResponsaveisSelecionados = customObj.responsaveis;
                    this.itemsAlunosSelecionados = customObj.alunos;
                    this.dataAniversario = customObj.dataAniversario;
                    this.dataVencimentoMensal = customObj.dataVencimentoMensal;
                    this.celular = customObj.celular;
                    this.tokenFMC = customObj.tokenFMC;
                    this.autorizacao = customObj.autorizacao;
                });

                console.log(this.currentPerfilSelect);
                if (this.perfilIIDSelected == 3) {
                    this.perfilNameSelected = 'Administrativo';
                }
                if (this.perfilIIDSelected == 4) {
                    this.perfilNameSelected = 'Administrativo/Professor';
                }
                if (this.perfilIIDSelected == 5) {
                    this.perfilNameSelected = 'Professor';
                }
                if (this.perfilIIDSelected == 6) {
                    this.perfilNameSelected = 'Responsável';
                }
                if (this.perfilIIDSelected == 7) {
                    this.perfilNameSelected = 'Aluno';
                }
                // console.log(this.perfilIIDSelected);
                // console.log(this.perfilNameSelected);
                this.currentPerfilSelect = {
                    value: {
                        perfilID: Number(this.perfilIIDSelected),
                        perfilName: this.perfilNameSelected
                    }
                };

                this.show = true;
                console.log(this.currentPerfilSelect);

                var storageRef = firebase.storage().ref();
                var tangRef = storageRef.child(
                    'profile/' + this.slug + '.' + this.extensao
                );

                // First we sign in the user anonymously
                //firebase.auth().signInAnonymously().then((result) => {
                // Once the sign in completed, we get the download URL of the image

                tangRef
                    .getDownloadURL()
                    .then(urlImgFB => {
                        // Once we have the download URL, we set it to our img element
                        console.log(urlImgFB);
                        this.urlImg = urlImgFB;
                    })
                    .catch(function(error) {
                        // If anything goes wrong while getting the download URL, log the error
                        console.error(error);
                    });

                this.loading = false;

                // validar cookie de 1 dia para setar pontuacao
                if ($.cookie('tela-perfil') != 'true') {
                    // Log do sistema
                    if (userProperties.escolaID != null) {
                        // timestamp
                        var now = new Date();
                        var year = '' + now.getFullYear();
                        var month = '' + (now.getMonth() + 1);
                        if (month.length == 1) {
                            month = '0' + month;
                        }
                        var day = '' + now.getDate();
                        if (day.length == 1) {
                            day = '0' + day;
                        }
                        var hour = '' + now.getHours();
                        if (hour.length == 1) {
                            hour = '0' + hour;
                        }
                        var minute = '' + now.getMinutes();
                        if (minute.length == 1) {
                            minute = '0' + minute;
                        }
                        var second = '' + now.getSeconds();
                        if (second.length == 1) {
                            second = '0' + second;
                        }
                        //return year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second;
                        var customtimestamp =
                            year + month + day + hour + minute + second;

                        db.collection('log_' + userProperties.escolaID)
                            .add({
                                escolaID: userProperties.escolaID,
                                slugAutor: userProperties.slug,
                                perfil: userProperties.perfil,

                                //slug: this.slug,
                                customtimestamp: customtimestamp,
                                dia: day,
                                mes: month,
                                ano: year,
                                acao: 'acessar',
                                categoria: 'perfil',
                                pontos: 1
                            })
                            .then(docRef => {
                                console.log(
                                    'Document written with ID: ',
                                    docRef.id
                                );
                                // set cookie
                                $.cookie('tela-perfil', 'true', { expires: 1 });
                            })
                            .catch(function(error) {
                                console.log('Error adding document: ', error);
                                console.log(
                                    'Erro no envio dos dados. Tente novamente mais tarde!'
                                );
                            });
                    } else {
                        alert(
                            'Sua sessão expirou, você será redirecionado para reautenticar!'
                        );
                        this.$router.push(`/`);
                    }
                }
            });
        //alert(userProperties.perfil);
        //userProperties.perfil = "test2";
    }
};
</script>

<style scoped>
.loading {
    position: absolute;
    top: 20%;
    left: 45%;
    z-index: 2;
}

.btCirculo {
    height: 30px;
    width: 30px;
}

.btCirculo a {
    color: #fff;
}

progress {
    width: 100%;
    margin-top: 6px;
}

label.v-label.theme--light {
    margin-bottom: 6px;
    display: block;
}

.adicionarItem.btCirculo {
    position: relative;
    top: 12px;
    left: 5px;
}

.excluirItem.btCirculo {
    position: relative;
    left: 5px;
    top: -10px;
}

.box-items-selecionados {
    background: silver;
    width: 100%;
    padding: 5px 5px 5px 10px;
}

.container {
    padding: 0 !important;
}

.avatar {
    float: left;
    width: 50px;
}

.container-pessoa {
    width: 100%;
    display: block;
    clear: both;
}

.box-aluno {
    margin-bottom: 5px;
    
}

.box-aluno img {
    width: 100%;
    padding-right: 10px;
}

.img {
    width: 120px;
    height: 120px;
    margin-right: 12px;
    border: beige solid 1px;
    border-radius: 50%;
    background-position: center top;
    background-size: 100% auto;
    position: relative;
    top: -6px;
    margin-left: 12px;
    margin: 10px auto 15px auto;
}

.img2{
    width: 60px;
    height: 60px;
    margin-right: 12px;
    border:beige solid 1px;
    border-radius: 50%;
    background-position: center top;
    background-size: 100% auto;
    position: relative;
    top:-2px;
    border: solid 4px #fff;
}


</style>
